var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// source/assets/modules-basis.js
var ScrollSnapSlider = class extends HTMLUListElement {
  constructor() {
    super();
    this.prevButton = this.parentNode.querySelector(
      ".slider-buttons .slider-button--prev"
    );
    this.nextButton = this.parentNode.querySelector(
      ".slider-buttons .slider-button--next"
    );
    this.indicators = this.parentNode.querySelectorAll(".indicator");
    this.currentIndicator = this.parentNode.querySelector(
      ".indicator .current-indicator"
    );
    this.isAutoplay = (this.dataset.autoplay || "false") === "true";
    this.isLoop = (this.dataset.loop || "false") === "true";
    this.isDraggable = (this.dataset.draggable || "false") === "true";
    this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3e3;
    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }
  init() {
    return __async(this, null, function* () {
      var _a, _b;
      const {
        ScrollSnapSlider: ScrollSnapSlider2,
        ScrollSnapDraggable,
        ScrollSnapAutoplay,
        ScrollSnapLoop
      } = yield import("mdl-scrollsnap");
      const sliderElement = this;
      const sliderSimple = new ScrollSnapSlider2({ element: this });
      const draggablePlugin = new ScrollSnapDraggable(70);
      const autoplayPlugin = new ScrollSnapAutoplay(this.autoplayInterval);
      const loopPlugin = new ScrollSnapLoop();
      this.slider = sliderSimple;
      draggablePlugin.slider = sliderSimple;
      autoplayPlugin.slider = sliderSimple;
      loopPlugin.slider = sliderSimple;
      (_a = this.prevButton) == null ? void 0 : _a.addEventListener("click", () => {
        autoplayPlugin.disableTemporarily();
        sliderSimple.slideTo(sliderSimple.slide - 1);
      });
      (_b = this.nextButton) == null ? void 0 : _b.addEventListener("click", () => {
        autoplayPlugin.disableTemporarily();
        sliderSimple.slideTo(sliderSimple.slide + 1);
      });
      for (const indicator of this.indicators) {
        indicator.addEventListener("click", function() {
          autoplayPlugin.disableTemporarily();
          const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex((item) => item.dataset.index === indicator.dataset.index);
          sliderSimple.slideTo(slideElementIndex);
        });
      }
      this.slider.addEventListener("slide-stop", (e) => {
        this.updateSlideState(e);
        this.updateIndicator(e);
      });
      if (!this.isLoop || this.isDraggable) {
        this.slider.addEventListener("slide-stop", () => {
          var _a2, _b2, _c, _d;
          (_a2 = this.prevButton) == null ? void 0 : _a2.removeAttribute("disabled");
          (_b2 = this.nextButton) == null ? void 0 : _b2.removeAttribute("disabled");
          if (sliderSimple.firstItemInView) {
            (_c = this.prevButton) == null ? void 0 : _c.setAttribute("disabled", "disabled");
          }
          if (sliderSimple.lastItemInView) {
            (_d = this.nextButton) == null ? void 0 : _d.setAttribute("disabled", "disabled");
          }
        });
      }
      if (this.isAutoplay) {
        this.enablePlugin(autoplayPlugin);
      }
      if (this.isLoop) {
        this.enablePlugin(loopPlugin);
      }
      if (this.isDraggable) {
        this.enablePlugin(draggablePlugin);
        if (this.isLoop) {
          this.disablePlugin(loopPlugin);
        }
        return;
      }
      this.disablePlugin(draggablePlugin);
    });
  }
  enablePlugin(plugin) {
    plugin.enable();
    this.slider.plugins.set(plugin.id, plugin);
  }
  disablePlugin(plugin) {
    plugin.disable();
    this.slider.plugins.delete(plugin.id);
  }
  updateSlideState(event) {
    const children = event.target.children;
    if (!children || event.detail < 0 || event.detail >= children.length) {
      return;
    }
    for (let child of children) {
      child.classList.remove("-active");
    }
    children[event.detail].classList.add("-active");
  }
  updateIndicator(event) {
    const slideElementIndex = event.detail;
    const slideElement = event.target.children[slideElementIndex];
    for (const indicator of this.indicators) {
      const isActive = indicator.classList.toggle(
        "-active",
        indicator.dataset.index === slideElement.dataset.index
      );
      if (isActive) {
        indicator.appendChild(this.currentIndicator);
      }
    }
  }
};
customElements.define("scroll-snap-slider", ScrollSnapSlider, {
  extends: "ul"
});
//# sourceMappingURL=modules-basis.js.map
